import { render } from "./DestinationsBlacklist.vue?vue&type=template&id=2a9dff1a"
import script from "./DestinationsBlacklist.vue?vue&type=script&lang=js"
export * from "./DestinationsBlacklist.vue?vue&type=script&lang=js"
script.render = render

export default script